// extracted by mini-css-extract-plugin
module.exports = {"selectText":"style_selectText__Oiadl","delete":"style_delete__hXT6W","deleteButton":"style_deleteButton__B2pKV","configurationTypes":"style_configurationTypes__KtLo8"};